'use client';

import React from 'react';
import { ArrowUpDown } from 'lucide-react';
import type { SortOption } from './SearchResultsContent';

const SORT_OPTIONS: { value: SortOption; label: string }[] = [
  { value: 'best-price', label: 'Meilleur prix' },
  { value: 'price-per-kg', label: 'Prix/kg' },
  { value: 'popularity', label: 'Popularité' },
  { value: 'most-retailers', label: 'Plus de marchands' },
];

interface Props {
  sort: SortOption;
  setSort: (s: SortOption) => void;
  resultCount: number;
}

export default function SortBar({ sort, setSort, resultCount }: Props) {
  return (
    <div className="flex items-center justify-between gap-4 flex-wrap">
      <p className="text-sm text-gray-500">
        <span className="font-semibold text-gray-800 tabular-nums">{resultCount}</span> produit{resultCount !== 1 ? 's' : ''}
      </p>
      <div className="flex items-center gap-2 flex-wrap">
        <span className="flex items-center gap-1.5 text-sm text-gray-500">
          <ArrowUpDown size={14} />
          Trier par :
        </span>
        <div className="flex gap-1.5 flex-wrap">
          {SORT_OPTIONS.map((opt) => (
            <button
              key={`sort-${opt.value}`}
              onClick={() => setSort(opt.value)}
              className={`text-sm px-3 py-1.5 rounded-xl border transition-all duration-150 active:scale-95 ${
                sort === opt.value
                  ? 'bg-orange-500 text-white border-orange-500 font-semibold' :'bg-white text-gray-600 border-gray-200 hover:border-orange-300 hover:text-orange-600'
              }`}
            >
              {opt.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}